export const RealLogo = ({ className = "h-11 w-auto" }) => (
  <img
    src="/images/logo-real.png"
    alt="Logo Rezydencja REAL"
    className={`${className} select-none`}
    data-testid="real-logo"
  />
);

export default RealLogo;
